const styles = {
  paper: {
    overflow: 'hidden',
  },
  topContainer: {display: 'flex', flexDirection: 'row', alignItems: 'center'},
  rowContainer: {
    flexDirection: 'row',
    display: 'flex',
    flex: 1,
    alignItems: 'center',
  },
  searchForm: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: 16,
    alignItems: 'flex-end',
  },
};

export default styles;
